import { TFunction } from 'i18next';
import { AIActionKind, AIInlineActionTemplate } from 'models/copilot/actions/aiActionTemplate';

/** The wizard runs the action itself: the hook passes the request it sends for that action. */
export type NewTaskWizardAIActionParams = { run: () => void };

// Adds checklist steps the task does not have yet.
export const newTaskWizardStepsTemplate: AIInlineActionTemplate<NewTaskWizardAIActionParams> = {
  id: 'newTaskWizard.steps',
  kind: AIActionKind.Inline,
  getLabel(t: TFunction<string[]>) {
    return t('task:NewTaskWizard.AI.Steps');
  },
  run(params) {
    params.run();
  },
};
